import React from 'react';

import { check } from '@/assets/icons';
import { classNames } from '@/helpers/classNames';
import constants from '@/theme/exportedVariables.module.scss';
import {
	ListItemIcon,
	ListItemText,
	Menu,
	MenuItem,
	MenuItemClassKey,
	MenuProps,
	PopoverOrigin,
	StyledComponentProps,
	SvgIcon,
	useMediaQuery,
} from '@material-ui/core';

import styles from './AsaphDropdownMenu.module.scss';

export type AsaphDropdownMenuProps = {
	open: boolean;
	anchorEl: Element | null;
	onClose: MenuProps['onClose'];
	items: {
		onClick?: () => void;
		classes?: StyledComponentProps<MenuItemClassKey>['classes'];
		label: string;
		value?: unknown;
		selected?: boolean;
		marked?: boolean;
	}[];
	customContent?: React.ReactNode;
	className?: string;
	listClassName?: string;
	selectable?: boolean;
	anchorOrigin?: Partial<PopoverOrigin>;
	transformOrigin?: Partial<PopoverOrigin>;
	width?: number;
};

export const AsaphDropdownMenu: React.FC<AsaphDropdownMenuProps> = ({
	open,
	anchorEl,
	onClose,
	items,
	customContent,
	anchorOrigin,
	transformOrigin,
	className,
	listClassName,
	selectable,
	width,
}) => {
	const isTablet = useMediaQuery(`(min-width: ${constants.sizeTablet}`);
	const mergedAnchorOrigin = Object.assign(
		{ vertical: 'bottom', horizontal: 'right' },
		anchorOrigin || {},
	) as PopoverOrigin;
	const mergedTransformOrigin = Object.assign(
		{ vertical: 'top', horizontal: 'right' },
		transformOrigin || {},
	) as PopoverOrigin;

	return (
		<Menu
			anchorEl={anchorEl}
			getContentAnchorEl={null}
			anchorOrigin={mergedAnchorOrigin}
			transformOrigin={mergedTransformOrigin}
			open={open}
			onClose={onClose}
			className={classNames([styles['asaph-menu'], className])}
			classes={{
				paper: classNames([styles['paper']]),
				list: classNames([styles['list'], listClassName]),
			}}
		>
			<div style={{ width: width || 'auto' }}>
				{customContent
					? customContent
					: items.map((item, index) => (
							<MenuItem
								key={`dropdown-menu-item-${index}`}
								onClick={item.onClick}
								selected={item.selected}
								classes={Object.assign(item.classes || {}, {
									root: classNames([
										styles['list-item'],
										isTablet && styles['hover'],
										selectable && styles['selectable'],
										item.classes?.root,
									]),
									selected: classNames([
										styles['list-item-selected'],
										item.classes?.selected,
									]),
								})}
							>
								{selectable && (
									<ListItemIcon
										classes={{
											root: classNames([
												styles['icon'],
												(item.selected ||
													item.marked) &&
													styles['active'],
											]),
										}}
									>
										{item.selected ? (
											<SvgIcon component={check} />
										) : (
											<div className={styles['mark']} />
										)}
									</ListItemIcon>
								)}
								<ListItemText>{item.label}</ListItemText>
							</MenuItem>
					  ))}
			</div>
		</Menu>
	);
};
